import { FilePack, FileDataset } from "@tblabs/storage";
import { Div, RefBool, MultipleFilesInput, Snack, Link, RefString } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/PrimaryButton";


export class FilesUploader extends Div
{
    private onSuccessfulUpload?: (pictures: FilePack[]) => void;

    constructor(dataset: FileDataset, tagsAsString: RefString)
    {
        super("add-field-box");

        const showUploader = new RefBool(false);

        this.Append(
            new PrimaryButton("Add files")
                .OnClick(async () => showUploader.True())
                .Invisible(showUploader),
            new MultipleFilesInput(async (files: File[]) =>
            {
                new Snack("Upload started", files.length + " files");

                try
                {
                    const tags = JSON.parse(tagsAsString.value || "[]");

                    if (tagsAsString.value && tags.length != files.length)
                    {
                        throw new Error("Number of tags must be equal number of files to upload");
                    }

                    const uploadedPictures = await dataset.Add(files, tags) as FilePack[];

                    new Snack("Upload finished", uploadedPictures.length + " files uploaded");

                    this.onSuccessfulUpload?.(uploadedPictures);
                }
                catch (error: any)
                {
                    console.error(error);
                    console.error("More error info can be found in the browser console or storage Exception log.");
                    new Snack("Upload failed", error.message, { autoCloseTimeout: 0 });
                }

                finally
                {
                    showUploader.False();
                }
            }).Visible(showUploader),
            new Link("×").FontSize(20).Color("red").Bold().CursorPointer().Style(`transform: translate(-16px, -12px);`).OnClick(() => showUploader.False())
                .Visible(showUploader)
        );
    }

    public OnSuccessfulUpload(onSuccessfulUpload: (pictures: FilePack[]) => void): this
    {
        this.onSuccessfulUpload = onSuccessfulUpload;

        return this;
    }
}
